const SUBMENU_LIST = "SUBMENU_LIST";

const CURRENT_SUBMENU = "CURRENT_SUBMENU";

const MOVE_PLACE = "MOVE_PLACE";

const MAINMENU_MOVEPLACE = "MAINMENU_MOVEPLACE";

const SET_MENU_DATA = "SET_MENU_DATA";

const state = {
  subMenuList: [],
  currentSubMenu: {},
  currentMovePlace: {},
  mainMenuMovePlace: 0,
  menuData: [], // 保存完整的菜单数据
};

const getters = {};

const actions = {
  setSubmenuList({ commit }, list) {
    commit(SUBMENU_LIST, list);
  },
  setCurrentSubMenu({ commit }, menu) {
    commit(CURRENT_SUBMENU, menu);
  },
  setCurrentMovePlace({ commit }, place) {
    console.log("place=>", place);
    commit(MOVE_PLACE, place);
  },
  setMainMenuMovePlace({ commit }, place) {
    commit(MAINMENU_MOVEPLACE, place);
  },
  setMenuData({ commit }, menuData) {
    commit(SET_MENU_DATA, menuData);
  },
};

const mutations = {
  [SUBMENU_LIST](state, list) {
    console.log("list=>", list);
    state.subMenuList = list;
  },
  [CURRENT_SUBMENU](state, menu) {
    state.currentSubMenu = menu;
  },
  [MOVE_PLACE](state, place) {
    state.currentMovePlace = place;
  },
  [MAINMENU_MOVEPLACE](state, place) {
    state.mainMenuMovePlace = place;
  },
  [SET_MENU_DATA](state, menuData) {
    state.menuData = menuData;
  },
};

export const menu = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
